export enum AssetType {
  VEHICLE,
  EQUIPMENT,
  MACHINE
}

export enum AssetLabelType {
  VEHICLE = 'Vehicle',
  EQUIPMENT = 'Equipment',
  MACHINE = 'Machine'
}

export default AssetType
